import {BaseService} from '../../../../../core/abstracts/base-service.abstract';
import {Creatable} from '../../../../../core/interfaces/base-service.interfaces';
import {VehicleReleaseRequest} from '../model/vehicle-release.request';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class VehicleReleaseService extends BaseService implements Creatable<{
  vehicleId: string,
  releasePayload: VehicleReleaseRequest
}, any> {
  protected readonly endpoint: string = '/items';

  constructor(private readonly httpClient: HttpClient) {
    super(httpClient);
  }

  create(payload: Required<{
    vehicleId: string,
    releasePayload: VehicleReleaseRequest
  }>): Observable<any> {
    return this.post(`/${payload.vehicleId}/release`, payload.releasePayload);
  }
}
